var map = {
	"./accordion1.svg": 1676,
	"./accordion3.svg": 5204,
	"./accordion4.svg": 2190,
	"./chart.svg": 7208,
	"./check.svg": 706,
	"./colored-logo.svg": 3646,
	"./error.svg": 9687,
	"./light.svg": 1821,
	"./logo1.svg": 7207,
	"./logo2.svg": 4034,
	"./partner1.svg": 4395,
	"./partner2.svg": 6974,
	"./partner3.svg": 9562,
	"./pen.svg": 9922,
	"./rocket.svg": 9614,
	"./speaker.svg": 3167,
	"./star-black.svg": 7283,
	"./star.svg": 3740,
	"./success.svg": 4398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;